export default function Container({ children, className = '' }: { children: React.ReactNode; className?: string }) {
    return <div className={`mx-auto w-[92vw] max-w-360 ${className}`}>{children}</div>
}
